/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, session: NonNullable<unknown> }} Plan_Edit_Removed_ToastInputs */

const en_us2_plan_edit_removed_toast = /** @type {(inputs: Plan_Edit_Removed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} left ${i?.session}`)
};

const pt_br2_plan_edit_removed_toast = /** @type {(inputs: Plan_Edit_Removed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} saiu do ${i?.session}`)
};

const es_419_plan_edit_removed_toast = /** @type {(inputs: Plan_Edit_Removed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} salió de ${i?.session}`)
};

const pt_pt2_plan_edit_removed_toast = /** @type {(inputs: Plan_Edit_Removed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} saiu do ${i?.session}`)
};

const fr_fr2_plan_edit_removed_toast = /** @type {(inputs: Plan_Edit_Removed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} a quitté ${i?.session}`)
};

const de_de2_plan_edit_removed_toast = /** @type {(inputs: Plan_Edit_Removed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} aus ${i?.session} entfernt`)
};

const it_it2_plan_edit_removed_toast = /** @type {(inputs: Plan_Edit_Removed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} rimosso da ${i?.session}`)
};

/**
* | output |
* | --- |
* | "{name} left {session}" |
*
* @param {Plan_Edit_Removed_ToastInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_edit_removed_toast = /** @type {((inputs: Plan_Edit_Removed_ToastInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Edit_Removed_ToastInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_edit_removed_toast(inputs)
	if (locale === "es-419") return es_419_plan_edit_removed_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_edit_removed_toast(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_edit_removed_toast(inputs)
	if (locale === "de-DE") return de_de2_plan_edit_removed_toast(inputs)
	if (locale === "it-IT") return it_it2_plan_edit_removed_toast(inputs)
	return en_us2_plan_edit_removed_toast(inputs)
});
export { plan_edit_removed_toast as "plan-edit.removed_toast" }